import { httpsCallable } from 'firebase/functions'
import { firebaseFunctions } from './firebase'
import { isNoSignInPreviewActive } from '../debug'

export interface SendSlackNotificationInput {
  workspaceId: string
  title?: string
  text: string
  channelOverride?: string
  targetUrl?: string
}

export interface SendSlackNotificationOutput {
  success: boolean
  channel: string
}

const callable = <I, O>(name: string) => httpsCallable<I, O>(firebaseFunctions, name)

export const formatSlackChannelName = (channel: string): string => {
  if (!channel) return ''
  const trimmed = channel.trim()
  if (!trimmed) return ''
  return trimmed.startsWith('#') ? trimmed : `#${trimmed}`
}

export const sendSlackNotification = async (
  input: SendSlackNotificationInput,
): Promise<SendSlackNotificationOutput> => {
  if (isNoSignInPreviewActive()) {
    return {
      success: true,
      channel: input.channelOverride ? formatSlackChannelName(input.channelOverride) : '#product-updates',
    }
  }

  const result = await callable<SendSlackNotificationInput, SendSlackNotificationOutput>(
    'sendSlackNotification',
  )(input)
  return result.data
}
